module.exports = __webpack_public_path__ + "img/cloudflare.dfa22cd2.png";